import axios from 'axios';

export const axiosAdmin = axios.create({
  baseURL: process.env.REACT_APP_SERVER_API,
});

axiosAdmin.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

// Add a request interceptor
axiosAdmin.interceptors.response.use(
  (response) => response, // Directly return successful responses.
  async (error) => {
    if (error.response.status === 401) {
      const originalRequest = error.config;
      originalRequest._retry = true;
      window.location.href = '/';
    }

    return Promise.reject(error);
  },
);
